import { message, Modal } from 'antd';
import { deleteInquiry } from '@/services/api/chatService';
import { useTranslation } from 'react-i18next';

const ModalDeleteInquiry: any = ({
  inquiry,
  removeInquiry,
  open,
  onCancel,
}: any) => {
  const { t } = useTranslation();
  const handleOk = async () => {
    const response = await deleteInquiry({ inquiry_id: inquiry.id });
    if (!response.success) {
      return;
    }
    removeInquiry(inquiry.id);
    onCancel();
  };
  return (
    <>
      <Modal
        title={t('home.chat.modals.delete.title')}
        open={open}
        onOk={handleOk}
        onCancel={onCancel}
        cancelText={t('home.chat.modals.delete.cancel')}
        okText={t('home.chat.modals.delete.confirm')}
        okType="danger"
      >
        {t('home.chat.modals.delete.content', { inquiryName: inquiry?.name })}
      </Modal>
    </>
  );
};

export default ModalDeleteInquiry;
